// extracted by mini-css-extract-plugin
export default {"contactListContainer":"ContactList_contactListContainer__Mco5m"};